/* eslint-disable @typescript-eslint/no-explicit-any, react-hooks/rules-of-hooks*/

import { Box } from "@mantine/core"
import React from "react"

import { ButtonWithDescription } from "@/components/ButtonWithDescription/ButtonWithDescription"
import { Label } from "@/components/Controlled/Controlled"
import { useStyles } from "@/components/SelectWithButtons/SelectWithButtons.styles"

export interface SelectWithButtonsProps {
    onChange: (value: number) => void
    options: {
        key: string | number
        value: number
        [key: string]: any
    }[]
    value?: number
    label?: string
}

export const SelectWithButtons = (props: SelectWithButtonsProps) => {
    const { classes } = useStyles()
    const renderButtons = () =>
        props.options
            .sort((a, b) => a.value - b.value)
            .map((item) => {
                return (
                    <ButtonWithDescription
                        key={item.key.toString()}
                        icon={item.icon}
                        iconFamily={item.iconFamily}
                        title={item.title}
                        description={item.description}
                        isActive={props.value === item.value}
                        onChange={props.onChange}
                        value={item.value}
                    />
                )
            })

    return (
        <Box className={classes.buttonGroup}>
            {props.label && <Label label={props.label} />}
            {renderButtons()}
        </Box>
    )
}
